export default __webpack_public_path__ + "static/media/mc_tube_rotor.a472c843.svg";